import { ConfirmDeleteDrawer } from '@dealstack/frontend/shared/components/ConfirmDeleteDrawer/ConfirmDeleteDrawer';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { OrganizationRes } from '@dealstack/shared/lib/generated';
import { useDeleteOrganization } from '@dealstack/frontend/app/pages/Organizations/hooks/useDeleteOrganization';

interface Props {
	opened: boolean;
	onClose: () => void;
	organization: OrganizationRes | null;
}

export const DeleteOrganizationConfirm = ({ opened, onClose, organization }: Props) => {
	const tOrganization = useTranslationOrganization();
	const { mutate: deleteOrg, isPending, isSuccess } = useDeleteOrganization();

	const handleDelete = () => {
		if (!organization?.id) {
			return;
		}
		deleteOrg(organization.id, { onSuccess: onClose });
	};

	return (
		<ConfirmDeleteDrawer
			opened={opened}
			onClose={onClose}
			title={tOrganization('organizations_management.delete.drawer.title')}
			promptText={tOrganization('organizations_management.delete.drawer.prompt')}
			alertTitle={tOrganization('organizations_management.delete.drawer.alert_title')}
			alertDescription={tOrganization(
				'organizations_management.delete.drawer.alert_description'
			)}
			confirmDeleteText={organization?.name ?? ''}
			inputLabel={tOrganization('organizations_management.delete.drawer.input_label')}
			inputPlaceholder={tOrganization(
				'organizations_management.delete.drawer.input_placeholder'
			)}
			wordMismatchErrorMessage={tOrganization(
				'organizations_management.delete.drawer.word_mismatch'
			)}
			deleteBtnText={tOrganization('organizations_management.delete.drawer.delete_button')}
			cancelBtnText={tOrganization('organizations_management.delete.drawer.cancel_button')}
			handleDelete={handleDelete}
			deleteLoading={isPending}
			deleteSuccess={isSuccess}
			enableDeleteButtonOnlyOnConfirmDelete
		/>
	);
};
